import { Autocomplete, Box, SxProps, TextField, Theme } from '@mui/material'

enum Role {
    user = 'user',
    admin = 'admin',
    superadmin = 'superadmin',
    atsp = 'atsp',
    atsp_user = 'atsp-user',
    superAtsp = 'superAtsp',
    dsa = 'dsa',
    dsa_user = 'dsa-user',
}

export type RoleName = `${Role}`

const defaultRoles: RoleName[] = Object.values(Role)

type SelectRoleProps = {
    setSelectedRole: React.Dispatch<React.SetStateAction<RoleName | undefined>>
    sx?: SxProps<Theme>
    required?: boolean
    defaultValue?: RoleName
    options?: RoleName[]
}

export default function SelectRole({
    setSelectedRole,
    sx,
    required,
    defaultValue,
    options,
}: SelectRoleProps) {
    const roleOptions: RoleName[] = options ?? defaultRoles
    const initialRole: RoleName = defaultValue ?? roleOptions[0]

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', ...sx }}>
            <Autocomplete
                fullWidth
                disablePortal
                options={roleOptions}
                defaultValue={initialRole}
                onChange={(_e, value) => setSelectedRole(value ?? initialRole)}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Organisation Role"
                        required={required}
                    />
                )}
            />
        </Box>
    )
}
